export default __webpack_public_path__ + "static/media/qr.035b72fe.svg";